import { Grid, Typography, Divider } from "@mui/material";
import React, { useState, useEffect } from "react";
import CheckoutForm from "./CheckoutForm";
import CheckoutItem from "./CheckoutItem";
import CheckoutSummary from "./CheckoutSummary";
import { getCartDetails } from "../../services/apiCalls";
import BreadCrumb from "../../components/BreadCrumb";

const CheckoutPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [discount, setDiscount] = useState(0);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const response = await getCartDetails();
        setCartItems(response.data || []);
      } catch (error) {
        console.error("Failed to fetch cart:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCart();
  }, []);

  const handleShippingChargeUpdate = (charge) => {
    setShippingCharge(parseFloat(charge) || 0);
  };

  const handleDiscountUpdate = (discountAmount) => {
    setDiscount(parseFloat(discountAmount) || 0);
  };

  const total = cartItems.reduce(
    (sum, item) =>
      sum + parseFloat(item.unit_price) * parseFloat(item.quantity),
    0
  );
  const breadcrumbUrls = [
    // { path: '/previous', label: 'Back' },
    { path: '/', label: 'Home' },
    { path: '/checkout', label: 'Checkout' },
  ];

  return (
    <div>

      <BreadCrumb title="Checkout" urls={breadcrumbUrls} />
      <Grid
        container
        sx={{ width: { xs: "100%", md: "1300px" }, mx: "auto", my: 6 }}
      >
        <Grid item xs={12} md={6} mr={{ xs: 0, md: 4 }} mb={{ xs: 4, md: 0 }}>
          <CheckoutForm
            onShippingChargeUpdate={handleShippingChargeUpdate}
            onDiscountUpdate={handleDiscountUpdate}
          />
        </Grid>
        <Grid item container rowGap={2} alignContent={"flex-start"} xs={12} md
          sx={{ border: "1px solid #ababab", alignSelf: "flex-start", }}>

          <Grid
            item
            container
            rowGap={2}
            xs={12}
            alignItems={"flex-start"}
            alignContent={"flex-start"}
          >

            <Typography variant="h6" sx={{ fontWeight: 300, textAlign: "center", padding: 1 }}>Order Summary</Typography>


            {cartItems.map((item) => (
              <Grid item xs={12} key={item.card_id}>
                <CheckoutItem
                  item={item}
                  currency={
                    cartItems.length > 0 ? cartItems[0].product.currency : "$"
                  }
                />

              </Grid>
            ))}

          </Grid>
          <Grid
            item
            xs={12}
            alignItems={"flex-start"}
            alignContent={"flex-start"}
          >
            <CheckoutSummary
              total={total}
              shippingCharge={shippingCharge}
              discount={discount}
              currency={
                cartItems.length > 0 ? cartItems[0].product.currency : "$"
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default CheckoutPage;
